export default __webpack_public_path__ + "static/media/peercoin-docs-banner.7543a13f.jpg";